module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Thin.ba43a4b4.ttf";